<template>
    <div class="w-1/4 md:w-1/6 flex flex-col px-4 mb-5">
        <p class="text-xs font-bold h-6 text-center uppercase leading-3 text-gray-700" v-html="texts[property]"></p>
        <p class="text-xl text-gray-500 text-center">{{ currentImmobile[property] }}<span class="text-xs">Km</span>
        </p>
    </div>
</template>
<script>
export default {
    name: 'distance',
    data() {
        return {
            texts: {
                DistanzaCentro: 'Centro',
                DistanzaNegozi: 'Negozi',
                DistanzaParcheggio: 'Parcheggio',
                DistanzaAutobus: 'Stazione <br /> Autobus',
                DistanzaMetropolitana: 'Stazione <br /> Metro',
                DistanzaStazioneFerroviaria: 'Stazione <br /> Treni',
                DistanzaAeroporto: 'Aeroporto',
                DistanzaPorto: 'Porto',
                DistanzaCaselloAutostradale: 'Autostrada',
                DistanzaMare: 'Mare',
                DistanzaLago: 'Lago',
                DistanzaImpiantiScii: 'Impianti <br /> Sciistici',
                DistanzaTerme: 'Terme',
            }
        }
    },
    props: {
        currentImmobile: {},
        property: {}
    },
    mounted() {
        this.$emit('distance-exists')
    }
}
</script>
